import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosImage, axiosPrivate, axiosPublic } from "./axiosProvider";

// Reusable AsyncThunk Generator
export const createApiThunkPublic = (name, url, method = "POST") => {
  return createAsyncThunk(name, async (payload, { rejectWithValue }) => {
    try {
      const config = { method, url, data: payload };
      const response = await axiosPublic(config);
      return response.data;
    } catch (error) {
      return rejectWithValue(JSON.stringify(error) || "Something went wrong!");
    }
  });
};

export const createApiThunkPrivate = (name, url, method = "POST") => {
  return createAsyncThunk(name, async (payload, { rejectWithValue }) => {
    try {
      const config = { method, url, data: payload };
      const response = await axiosPrivate(config);
      return response.data;
    } catch (error) {
      return rejectWithValue(JSON.stringify(error) || "Something went wrong!");
    }
  });
};

export const createApiThunkPrivateImage = (name, url, method = "POST") => {
  return createAsyncThunk(name, async (payload, { rejectWithValue }) => {
    try {
      const config = { method, url, data: payload };
      const response = await axiosImage(config);
      return response.data;
    } catch (error) {
      return rejectWithValue(JSON.stringify(error) || "Something went wrong!");
    }
  });
};

export const createExtraReducersForThunk = (
  builder,
  thunkAction,
  sliceName
) => {
  builder
    .addCase(thunkAction.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(thunkAction.fulfilled, (state, action) => {
      state.loading = false;
      state[sliceName].data = action.payload?.data || {}; // You can replace `data` with a more appropriate key like `usersDetails` based on each case
    })
    .addCase(thunkAction.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message ||
        `Something went wrong while fetching ${sliceName} details.`;
    });
};
